module.exports = __webpack_public_path__ + "valhalaCaracter.png";